import clsx from 'clsx';
import PropTypes from 'prop-types';

import Icon from '@/components/base/Icon';

export const ActionButton = ({
    icon,
    onClick,
    setReferenceElement,
    className,
    disabled,
    ...restProps
}) => {
    return (
        <button
            ref={setReferenceElement}
            className={clsx(
                'flex items-center space-x-2 rounded-2xl p-2.5 text-xs !ring-offset-0',
                { 'bg-icoGray-300 text-icoGray-400': disabled },
                className
            )}
            onClick={(e) => {
                e.stopPropagation();
                onClick();
            }}
            disabled={disabled}
            {...restProps}>
            <Icon icon={icon} className="text-sm" />
            <Icon icon="plus-sign" className="text-sm" />
        </button>
    );
};

ActionButton.propTypes = {
    icon: PropTypes.string,
    onClick: PropTypes.func,
    setReferenceElement: PropTypes.func,
    className: PropTypes.string,
    disabled: PropTypes.bool
};
